<template>
	<b-modal
		ref="create-tournament-beneficiary-modal"
		:title="`${beneficiary ? 'Editar' : 'Crear'} Beneficiario`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		size="md"
		:ok-disabled="isLoading"
		:cancel-disabled="isLoading"
		no-close-on-esc
		@ok.prevent="beneficiary ? updateBeneficiary() : createBeneficiary()"
		:ok-title="isLoading ? 'Guardando...' : 'Guardar'"
	>
		<div>
			<validation-observer tag="b-row" ref="form">
				<b-col cols="12">
					<validation-provider rules="required" v-slot="{ errors, valid }">
						<b-form-group label="Nombre" label-for="name">
							<b-form-input
								placeholder="Nombre del beneficiario"
								v-model="name"
								:state="errors[0] ? false : valid ? true : null"
								@input="(val) => (name = name.toUpperCase())"
							/>
							<span style="color: red">{{ errors[0] }}</span>
						</b-form-group>
					</validation-provider>
				</b-col>

				<b-col cols="12">
					<validation-provider rules="required" v-slot="{ errors, valid }">
						<b-form-group label="Telefono" label-for="phone">
							<b-form-input
								v-model="phone"
								:state="errors[0] ? false : valid ? true : null"
								v-mask="'###-###-###'"
								placeholder="Ingrese numero de telefono"
							/>
							<span style="color: red">{{ errors[0] }}</span>
						</b-form-group>
					</validation-provider>
				</b-col>
				<b-col cols="12">
					<b-form-group>
						<label for="bank">Banco</label>
						<v-select
							class="bg-white rounded"
							label="name"
							:options="arrayBanks"
							:reduce="(opt) => opt.id"
							:clearable="false"
							placeholder="Seleccionar banco"
							v-model="bank_id"
						/>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group>
						<label for="currency">Moneda</label>
						<v-select
							class="bg-white rounded"
							label="name"
							:options="arrayCurrency"
							:reduce="(opt) => opt.id"
							:clearable="false"
							placeholder="Seleccionar moneda"
							v-model="currency"
						/>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group>
						<label for="bank">Nro Cuenta</label>
						<b-form-input
							placeholder="Ingresar nro de cuenta"
							v-model="account_number"
							@input="(val) => (account_number = account_number.toUpperCase())"
						/>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group>
						<label for="bank">CCI</label>
						<b-form-input
							placeholder="Ingresar CCI"
							v-model="cci"
							@input="(val) => (cci = cci.toUpperCase())"
						/>
					</b-form-group>
				</b-col>
			</validation-observer>
		</div>
	</b-modal>
</template>

<script>
import TournamentBeneficiariesService from "@/views/brain/tournament/views/beneficiaries/beneficiaries.service.js"
export default {
	props: {
		beneficiary: {
			type: Object,
			default: () => ({
				id: null,
				name: "",
				phone: "",
				bank_id: "",
				currency: null,
				account_number: "",
				cci: "",
			}),
		},
	},
	data() {
		return {
			name: "",
			phone: "",
			bank_id: "",
			currency: null,
			account_number: "",
			cci: "",
			arrayCurrency: [
				{
					id: "$",
					name: "Dólares (US$)",
				},
				{
					id: "S/.",
					name: "Soles (S/.)",
				},
			],
			arrayBanks: [],
			isLoading: false,
		}
	},
	computed: {},
	methods: {
		handleHidden() {
			this.$emit("close")
		},
		async getBanks() {
			try {
				const { data } = await TournamentBeneficiariesService.getBanks()
				this.arrayBanks = data
			} catch (error) {
				console.error("Error fetching banks:", error)
			}
		},
		async createBeneficiary() {
			try {
				const isValid = await this.$refs.form.validate()
				if (!isValid) return
				const { isConfirmed } = await this.showConfirmSwal({
					title: "¿Estás seguro de crear este beneficiario?",
					text: "Se creará un nuevo beneficiario con los datos proporcionados.",
				})
				if (!isConfirmed) return
				this.isPreloading()
				this.isLoading = true
				await TournamentBeneficiariesService.store({
					name: this.name,
					phone: this.phone,
					bank_id: this.bank_id,
					currency: this.currency,
					account_number: this.account_number,
					cci: this.cci,
				})
				this.showSuccessToast("Beneficiario creado correctamente")
				this.$emit("refresh")
				this.handleHidden()
			} catch (error) {
				console.error("Error creating beneficiary:", error)
			} finally {
				this.isLoading = false
				this.isPreloading(false)
			}
		},

		async updateBeneficiary() {
			try {
				const isValid = await this.$refs.form.validate()
				if (!isValid) return
				const { isConfirmed } = await this.showConfirmSwal({
					title: "¿Estás seguro de actualizar este beneficiario?",
					text: "Se actualizarán los datos del beneficiario con la información proporcionada.",
				})
				if (!isConfirmed) return
				this.isPreloading()
				this.isLoading = true
				await TournamentBeneficiariesService.update(this.beneficiary.id, {
					name: this.name,
					phone: this.phone,
					bank_id: this.bank_id,
					currency: this.currency,
					account_number: this.account_number,
					cci: this.cci,
				})
				this.showSuccessToast("Beneficiario actualizado correctamente")
				this.$emit("refresh")
				this.handleHidden()
			} catch (error) {
				console.error("Error updating beneficiary:", error)
			} finally {
				this.isLoading = false
				this.isPreloading(false)
			}
		},
	},

	async mounted() {
		if (this.beneficiary) {
			this.name = this.beneficiary.name
			this.phone = this.beneficiary.phone
			this.bank_id = this.beneficiary.bank_id
			this.currency = this.beneficiary.currency
			this.account_number = this.beneficiary.account_number
			this.cci = this.beneficiary.cci
		}
		await this.getBanks()
		this.$refs["create-tournament-beneficiary-modal"].toggle()
	},
}
</script>

<style scoped lang="scss"></style>
